module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product28-82dd5ecd6d7b1d2bf6ccc0c11b01d744.jpg";